/**
 * @Author: chengzh
 * @Date:   2021-07-07 10:05:16
 * @Last Modified by:   chengzh
 * @Last Modified time: 2021-08-23 14:15:37
 */
const ecosystemEnv = require('../config/ecosystem.config');
import getConfig from 'next/config';
import Router from 'next/router';
import { cpf, cnpj } from 'cpf-cnpj-validator';
const { publicRuntimeConfig } = getConfig();
// 从环境变量中取MODE，配置在next.config.js和package.json文件中
const ENV = publicRuntimeConfig.env.NEXT_PUBLIC_ENV;
const pako = require('pako');

import * as Sentry from "@sentry/react";
import {
  captureMessage
} from 'fe-monitor-sdk';



// 获取 url 参数
export function getUrlParams (name) {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)'); //构造一个含有目标参数的正则表达式对象
  if (process.browser) {
    const r = window.location.search.substr(1).match(reg); //匹配目标参数
    if (r != null) return unescape(r[2]);
    return null; //返回参数值
  }
}

// 给官方演示站点用，用于关闭真实开发环境不需要使用的特性
export function isAntdPro () {
  return window.location.hostname === 'preview.pro.ant.design';
}


/**
 * 设置重定向路径前缀
 */
export function getUrlPrefix () {
  if (process.browser) {
    let urlPrefix = '';
    // 优先从pm2环境变量获取HOST，如果没有则从ecosystem.config.js获取
    urlPrefix = process.env.HOST || ecosystemEnv[ENV];
    // const HOST = window.location.host;
    // if (HOST.indexOf('localhost') > -1) {
    //   // 开发环境
    //   urlPrefix = 'http://192.168.127.12:8080/apigw';
    // } else if (
    //   HOST.indexOf('192.168.136.23:85') > -1 ||
    //   HOST.indexOf('gacashier.lianlianpay-inc.com') > -1
    // ) {
    //   // 沙箱环境
    //   urlPrefix = 'https://celer-gateway.lianlianpay-inc.com';
    // } else if (HOST.indexOf('192.168.130.89:85') > -1) {
    //   // 测试环境
    //   urlPrefix = 'http://192.168.130.58:8898';
    // } else if (HOST.indexOf('secure-checkout.lianlianpay.com') > -1) {
    //   // 生产环境
    //   urlPrefix = 'https://secure-checkout.lianlianpay.com/gw';
    // } else {
    //   // 开发环境
    //   urlPrefix = 'http://192.168.127.12:8080/apigw';
    // }
    return urlPrefix;
  } else {
    return null;
  }
}
/**
 *动态获取环境
 */
export function getEnv () {
  return ENV;
}



// 跳转到 URL
export const redirect_urlFn = redirect_url => {
    const urlPrefix = getUrlPrefix();
    if (redirect_url) {
      if (redirect_url.indexOf('http') > -1) {
        window.location.href = redirect_url;
      } else {
        window.location.href = `${urlPrefix}${redirect_url}`;
      }
    }
  };


/**
 *动态获取http://localhost:2028/oxo中的oxo等。
 */
export function getPaymentType () {
  let paymentType;
  if (process.browser) {
    if (typeof location !== 'undefined') {
      const pathname = location.pathname;
      if (pathname.indexOf('h5') > -1) {
        paymentType = location.pathname.substring(4); // lcr,icr,oxo
      } else {
        paymentType = location.pathname.substring(1); // lcr,icr,oxo
      }
      // 特殊处理
      if (paymentType === 'card-elements') {
        paymentType = 'icr';
      }
    }
  }
  return paymentType;
}

// 银行卡模10算法
export function mod10ValidateCreditCard (s) {
  // remove non-numerics
  var v = '0123456789',
    w = '',
    i,
    j,
    k,
    m,
    c,
    a,
    x;
  for (i = 0; i < s.length; i++) {
    x = s.charAt(i);
    if (v.indexOf(x, 0) !== -1) {
      w += x;
    }
  }
  // validate number
  j = w.length / 2;
  k = Math.floor(j);
  m = Math.ceil(j) - k;
  c = 0;
  for (i = 0; i < k; i++) {
    a = w.charAt(i * 2 + m) * 2;
    c += a > 9 ? Math.floor(a / 10 + (a % 10)) : a;
  }
  for (i = 0; i < k + m; i++) {
    c += w.charAt(i * 2 + 1 - m) * 1;
  }
  return c % 10 === 0;
}

/*
 * 描述：动态取得本地资源文件内容
 * helloParam: "第一个参数{first},第二个参数{second}}."
 * 参数：
 *   key 对应的资源的key
 *   params 对应资源中的参数对象(Hash)
 *
 * 返回：对应的资源内容
 *
 * 用法：
 * 		getLocale("helloParam",{first:value1,second:value2});
 */
let JSLocale = {
  // helloParam: '第一个参数{{:first}},第二个参数{{:second}}.',
  helloParam: '第一个参数{first},第二个参数{second}.',
};

export function getJSLocale (key, params) {
  var result = ''; // 对应的资源的内容
  var paramsObj = {}; // 参数对象
  if (params) paramsObj = params;

  if (typeof key != 'undefined' && typeof JSLocale != 'undefined') {
    // 根据key取得对应的资源内容，如果没有找到则返回key值
    if (JSLocale[key] != undefined) {
      result = JSLocale[key];
    } else {
      result = key;
    }

    // 替换对应参数为value的值
    let regExp;
    for (var k in paramsObj) {
      regExp = `{${k}}`;
      result = result.replace(new RegExp(regExp, 'g'), paramsObj[k]);
    }
    // 如果没有找到对应的资源则返回 ""
    // if (/{[a-zA-Z]+}/.test(result)) {
    //   result = result.replace(/{[a-zA-Z]+}/g, '');
    // }
  }
  return result;
}


/**
 * 动态获取最后一个/前面的内容，与YApi的接口对应，在google analytics埋点中使用
 */

 export function getInterfaceUrl(url) {
  let index = url.lastIndexOf('/');
  return url.substring(0, index)
}


/**
 *  金额显示.00格式
 */

export function NumFormat(value) {
  if (!value) return '0.00'
  value = value.toFixed(2)
  var intPart = Math.trunc(value) // 获取整数部分
  var floatPart = '.00' // 预定义小数部分
  var value2Array = value.split('.')
  // =2表示数据有小数位
  if (value2Array.length === 2) {
    floatPart = value2Array[1].toString() // 拿到小数部分
    if (floatPart.length === 1) {
      return intPart + '.' + floatPart + '0'
    } else {
      return intPart + '.' + floatPart
    }
  } else {
    return intPart + floatPart
  }
}

// CPF:11位
// CNPJ：14位
// 1、输入的长度=11位，按CPF校验格式化
// 2、输入的长度=14位，按CNPJ校验格式化
// 3、其余，不CPF/CNPJ校验格式化 提示无效
export function formatCardHolderIdNoVal(val){
  let newVal = val ? val.replace(/[^0-9]/gi, '') : '';
  const length = newVal.length;
  if (length === 11 && cpf.isValid(val)) {
    return cpf.format(val);
  } 
  if (length === 14 && cnpj.isValid(val)) {
    return cnpj.format(val);
  } 
  return val
}



export function getPaymentData(type, allData, resData) {
  
  console.log('allData', allData);
  console.log('resData', resData);
  // 重新赋值不同支付方式数据
  let result = {
    data: {
      key: orNULL(allData.key),
      orderId: orNULL(allData.orderId),
      // 公钥和token从接口中获取
      publicKey: orNULL(resData.publicKey),
      token: orNULL(resData.token),
      backHomePage: orNULL(allData.backHomePage),

      ttl: orNULL(allData.ttl),
      merchantOrderNo: orNULL(allData.merchantOrderNo),
      products: orNULL(allData.products),
      paymentCurrency: orNULL(allData.paymentCurrency),
      paymentAmount: orNULL(allData.paymentAmount),
      actualPaymentAmount: orNULL(allData.actualPaymentAmount),
      actualPaymentCurrency: orNULL(allData.actualPaymentCurrency),
      actualPaymentCurrencySymbol: orNULL(allData.actualPaymentCurrencySymbol),
      totalCurrency: orNULL(allData.totalCurrency),
      totalCurrencySymbol: orNULL(allData.totalCurrencySymbol),
      totalAmount: orNULL(allData.totalAmount),
      taxCurrency: orNULL(allData.taxCurrency),
      taxAmount: orNULL(allData.taxAmount),
      merchantId: orNULL(allData.merchantId),
      contextPath: orNULL(allData.contextPath),
      email: orNULL(allData.email),
      showEuropeFlag: orNULL(allData.showEuropeFlag),
      description: orNULL(allData.description),
      companyName: orNULL(allData.companyName),
      orderServiceChargeAmount: orNULL(allData.orderServiceChargeAmount),
      cardNo: orNULL(allData.cardNo),
      cardName: orNULL(allData.cardName),
      phoneFix: orNULL(allData.phoneFix),
      phoneNumber: orNULL(allData.phoneNumber),
      cashierModelRuleMap: orNULL(resData.cashierModelRuleMap),
    }
  }
  
  for(var i = 0; i < allData.payments.length ; i++){
    // console.log(allData.payments[i].paymentMethod)
    const cardBrands = orNULL(allData.payments[i].cardBrands);
    const paymentInfoData = orNULL(allData.payments[i].paymentInfoData);
    // console.log(paymentInfoData)
    const authType = orNULL(allData.payments[i].authType);
    const bankCodes = orNULL(allData.payments[i].bankCodes);
    if(allData.payments[i].paymentMethod.toLowerCase() === type){ 
      authType ? result.data.authType = authType : '';
      bankCodes ? result.data.bankCodes = bankCodes : '';
      cardBrands ? result.data.cardBrands = cardBrands : '';
      paymentInfoData ? Object.keys(paymentInfoData).map((index) => { 
        // console.log(paymentInfoData[index])
        result.data[index] = paymentInfoData[index];
      })
      :
      ''
    }
  }

  // console.log(result)
  return result;
}

function orNULL(data){
  return data || ''
}

  
// 内存代替浏览器存储，解决无痕模式
class MemoryStorage{
  /**
   * @name 构造方法
   */
  constructor() {
    this.data = {}
  }
  /**
   * @name 保存
   * @param name 键名
   * @param value 键值
   */
  setItem(name, value) {
    this.data[name] = value
  }
  /**
   * @name 取值
   * @param name 键名
   */
  getItem(name) {
    return this.data[name]
  }
  /**
   * @name 删除
   * @param name 键名
   */
  removeItem(name) {
    delete this.data[name]
  }
  /**
   * @name 判断是否包含
   * @param {*} name 键名
   * @returns 
   */
  contains(name){
    return name in this.data
  }
  /**
   * @name 清空
   */
  clear() {
    this.data.clear()
  }
}

let localStorage, sessionStorage

try{
  localStorage = window.localStorage
  sessionStorage = window.sessionStorage
} catch {
  // 不支持浏览器存储时，使用内存存储
  localStorage = new MemoryStorage()
  sessionStorage = new MemoryStorage()
}

export {
  localStorage,
  sessionStorage
}


/**
 * google analytics 埋点处理
 * @param {*} type 操作位置：接口、支付页面、支付成功页、Boleto页面、Pix页面
 * @param {*} record 操作记录：[0]表示操作事件名；[1]操作事件值
 * @param {*} event_category 操作客户端：WEB || H5
 * @param {*} event_label  操作名称
 * @param {*} value 操作次数
 */
 export function gtag(type, record){
  // const h5OrWeb = localStorage.getItem('isMobileView') === 'WEB' ? 'WEB' : 'H5';
  
  // // console.log(type, `${h5OrWeb}收银台`, record[0], record[1] ? record[1] : '');
  // window.gtag('event', type, {
  //   event_category: `${h5OrWeb}收银台`,
  //   event_label: record[0],
  //   value: record[1] ? record[1] : '',
  // })

 }




 
/**
 * @file UA 解析器 / ES module
 * @module transforms/ua-device
 * @author Surmon <https://github.com/surmon-china>
 */

export default userAgent => ({
	isEdge: userAgent.includes('Edge'),
	isFF: userAgent.includes('Firefox'),
	isOpera: userAgent.includes('Opera'),
	isBB: userAgent.includes('BlackBerry'),
	isChrome: userAgent.includes('Chrome'),
	isMaxthon: userAgent.includes('Maxthon'),
	isIos: /(iPhone|iPad|iPod|iOS)/i.test(userAgent),
	isIE: ['compatible', 'MSIE'].every(n => userAgent.includes(n)),
	isSafari: userAgent.includes('Safari') && !userAgent.includes('Chrome'),
	isMobile: /(iPhone|iPod|Opera Mini|Android.*Mobile|NetFront|PSP|BlackBerry|Windows Phone|harmony.*Mobile|harmony.*Phone|ArkWeb.*Mobile)/gi.test(
		userAgent
	)
})



function Utf8ArrayToStr(array) {
	var out, i, len, c;
	var char2, char3,out = "";
	len = array.length;
	i = 0;
	while (i < len) {
		c = array[i++];
		switch (c >> 4) {
			case 0:
			case 1:
			case 2:
			case 3:
			case 4:
			case 5:
			case 6:
			case 7:
				// 0xxxxxxx
				out += String.fromCharCode(c);
				break;
			case 12:
			case 13:
				// 110x xxxx   10xx xxxx
				char2 = array[i++];
				out += String.fromCharCode(((c & 0x1F) << 6) | (char2 & 0x3F));
				break;
			case 14:
				// 1110 xxxx  10xx xxxx  10xx xxxx
				char2 = array[i++];
				char3 = array[i++];
				out += String.fromCharCode(((c & 0x0F) << 12) |
					((char2 & 0x3F) << 6) |
					((char3 & 0x3F) << 0));
				break;
		}
	}

	return out
}

export function unzip(b64Data) {
  if (window === undefined) return;
  
  let strData;
  try { 
    strData = atob(b64Data)
  } catch {
    return false;
  }
	// Convert binary string to character-number array
	const charData = strData.split('').map(function (x) {
		return x.charCodeAt(0)
  })
	// Turn number array into byte-array
  let binData = null, data
  binData = new Uint8Array(charData)


	try {
		data = pako.inflate(binData)
	} catch {
    //Router.push('/time-out')
    // paymentData解压失败
    return false;
  }

	return Utf8ArrayToStr(data);
}


// 写一段方法，判断某个数据是否在该数组中， 如果没有，则抛出异常，且不阻塞进程

export function checkDataInArray(type, data, array) {
  try {
    throw new Error(data);
  } catch (e) {
    Sentry.captureException(e);
  }
}





// 判断对象为空
export function isEmptyObject(obj) { 
  return JSON.stringify(obj) === '{}'
}



// 上报事件到连连卫士和sentry
export async function reportEventToMonitor(text, type, code) {
    switch (type) {
      case 'CODE':
        const CODE_DATA = ['400004', '401005', '403006', '409015', '409016', '409123', '422015', '422016', '422017', '422019', '423000', '423005', '409011',
          '423007', '200000', '200100', '500900', '600000', '600007', '600008', '600020', '900000', '980000', '600001', '600002', '990000', 'C121', 'C124', 'C126', 'C131', 'C320', 'C122', 'P900'
        ]
        // 判断数据是否在数组中
        if (!CODE_DATA.includes(code?.toString())) {
           throw new Error(text);
        }
        break;
      default:
        throw new Error(text);
    }
}


// 比较两个数组是否有相同的值
export function arraysHaveCommonValues(arr1, arr2) {
  // 使用 Set 数据结构来存储一个数组的值
  const set1 = new Set(arr1);

  // 遍历另一个数组，检查是否有共同的值
  for (let value of arr2) {
    if (set1.has(value)) {
      return true;
    }
  }

  return false;
}
